import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICanlyniadChwilio } from "../../modelau/canlyniad-chwilio";
import { FfeilUwchlwytho } from "../../modelau/ffeil/ffeil-uwchlwytho";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class FfeilService {
  constructor(private apiService: ApiService) {}

  nolFelByteArray(id: number): Observable<any> {
    return this.apiService.get(`/ffeil/nolfelbytearray/${id}`, undefined, "blob" as "json");
  }

  uwchlwytho(url: string, ffeil: FfeilUwchlwytho): Observable<any> {
    return this.apiService.post(url, ffeil);
  }

  nolDelweddauCerbyd(cerbydId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/noldelweddaucerbyd/${cerbydId}`);
  }

  nolFfeiliauCerbyd(cerbydId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/nolffeiliaucerbyd/${cerbydId}`);
  }

  nolDelweddauGwaith(gwaithId: number, diogelwch: boolean): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/noldelweddaugwaith/${gwaithId}/${diogelwch}`);
  }

  nolFfeiliauGwaith(gwaithId: number, diogelwch: boolean): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/nolffeiliaugwaith/${gwaithId}/${diogelwch}`);
  }

  dileuFfeilGwaith(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileuffeilgwaith/${id}`);
  }

  nolDelweddauDamwain(damwainId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/noldelweddaudamwain/${damwainId}`);
  }

  nolFfeiliauDamwain(damwainId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/nolffeiliaudamwain/${damwainId}`);
  }

  dileuDelweddDamwain(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileudelwedddamwain/${id}`);
  }

  dileuFfeilDamwain(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileuffeildamwain/${id}`);
  }

  dileuDelweddCerbyd(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileudelweddcerbyd/${id}`);
  }

  dileuFfeilCerbyd(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileuffeilcerbyd/${id}`);
  }

  nolDefnyddiwrLlofnod(id: string): Observable<string> {
    return this.apiService.get(`/ffeil/noldefnyddiwrllofnod/${id}`);
  }

  nolDelweddauArcheb(archebId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/noldelweddauarcheb/${archebId}`);
  }

  nolFfeiliauArcheb(archebId: number): Observable<ICanlyniadChwilio> {
    return this.apiService.get(`/ffeil/nolffeiliauarcheb/${archebId}`);
  }

  dileuDelweddArcheb(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileudelweddarcheb/${id}`);
  }

  dileuFfeilArcheb(id: number): Observable<any> {
    return this.apiService.delete(`/ffeil/dileuffeilarcheb/${id}`);
  }

  nolTempledTanwydd(): Observable<any> {
    return this.apiService.get(`/ffeil/noltempledtanwydd`, undefined, "blob" as "json");
  }

  dileuFfeilGyrrwr(id: number) {
    return this.apiService.delete(`/ffeil/dileuffeilgyrrwr/${id}`);
  }

  nolFfeiliauGyrrwr(gyrrwrId: number) {
    return this.apiService.get(`/ffeil/nolffeiliaugyrrwr/${gyrrwrId}`);
  }
}
